<app-navbar *ngIf="routerOutlet.activatedRouteData['showNavBar']"></app-navbar>
<router-outlet #routerOutlet="outlet"></router-outlet>
